import { motion } from "framer-motion";

export const SectionTitle = ({ eyebrow, title, subtitle, align = "center" }) => {
  const isCenter = align === "center";
  return (
    <div className={`mb-16 ${isCenter ? "text-center" : "text-left"}`} data-testid="section-title">
      {eyebrow && (
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 0.6 }}
          className={`inline-flex items-center gap-3 text-xs tracking-[0.3em] uppercase text-[hsl(var(--gold-deep))] dark:text-[hsl(var(--gold-light))] mb-5 ${isCenter ? "" : ""}`}
        >
          <span className="h-px w-8 bg-[hsl(var(--gold))]/60" />
          {eyebrow}
          <span className="h-px w-8 bg-[hsl(var(--gold))]/60" />
        </motion.div>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.7, ease: [0.2, 0.8, 0.2, 1] }}
        className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className={`mt-6 text-base md:text-lg text-muted-foreground ${isCenter ? "max-w-2xl mx-auto" : "max-w-2xl"}`}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
};
